export default __webpack_public_path__ + "static/media/FuturaPT-Demi.11b3b844.woff2";